import { client } from '~shared/api';

import { PinCodeDtoScheme } from '../model/dto.ts';

export async function fetchPinCodes() {
	const data = await client.get('/pin-code');
	return PinCodeDtoScheme.parse(data);
}
